<span class="text-white font-small">
    <!-- Tempo de Sessão: {{ timeLeftFormatted }} -->
    <!-- Tempo de Renovacao: {{ timeRenovacao }} -->
</span>
